export function getProcessAsLargeItemStorage(username: string) {
  const storageKey = `largeItem_${username}`;
  const savedProcessAsLargeItem = localStorage.getItem(storageKey) === 'true';
  return savedProcessAsLargeItem;
}

export function setProcessAsLargeItemStorage(value: boolean, username: string) {
  const storageKey = `largeItem_${username}`;
  const booleanToStringValue = value ? 'true' : 'false';
  localStorage.setItem(storageKey, booleanToStringValue);
}

// Force-resync handshake. `DataStore.stop()` can hang indefinitely while an initial
// full sync is mid-flight, so we cannot reliably stop+clear+reload inline. Instead
// the popover sets this flag and reloads immediately (interrupting the in-flight
// sync); on the next boot the DataStore provider consumes it and clears the store
// BEFORE `DataStore.start()` — the safe window where clear is fast — guaranteeing a
// true full re-sync from scratch.
const FORCE_RESYNC_ON_BOOT_KEY = 'ftl.forceResyncOnBoot';

export function setForceResyncOnBoot(): void {
  try {
    localStorage.setItem(FORCE_RESYNC_ON_BOOT_KEY, 'true');
  } catch {
    // Storage unavailable; a plain reload still resumes/repairs the sync.
  }
}

// Returns true once if a force-resync was requested, clearing the flag so the wipe
// happens exactly one boot (read-and-clear is atomic from the caller's view).
export function consumeForceResyncOnBoot(): boolean {
  try {
    const requested = localStorage.getItem(FORCE_RESYNC_ON_BOOT_KEY) === 'true';
    if (requested) localStorage.removeItem(FORCE_RESYNC_ON_BOOT_KEY);
    return requested;
  } catch {
    return false;
  }
}
